import React, { FC, useEffect, useMemo, useRef, useState, SyntheticEvent } from 'react'
import { observer } from 'mobx-react'
import { Checkbox, Image } from 'antd'
import { hot } from 'react-hot-loader/root'
import { AppStore } from 'src/pc/store/AppStore'
import { PlatformIconByPlatformName } from 'src/commons/utils/DOMUtils'
import { fitImgUrl } from 'src/pc/utils/util'
import { activityNo } from 'src/pc/activity/23-6-16'
import {
  toChinesePackageBuyDetail,
  toArchiveBuyDetail,
  toMODBuyDetail,
  toBoosterBuyDetailUrl,
  toCloudTimeBuyDetailUrl,
} from 'src/pc/store/UIController'
import htmr from 'htmr'
import DDImage from 'src/pc/components/dd-image'
import useIsLogin from 'src/pc/components/hooks/useIsLogin'
import DefaultAvatar from 'src/pc/assets/images/DefaultAvatar.png'
import styled from '@emotion/styled'
import DDModal from 'src/pc/components/DDModal'
import timeImg from 'src/pc/assets/images/activity/23-6-16/time.png'
import closeImg from 'src/pc/assets/images/activity/23-6-16/close.png'
import sizeImg from 'src/pc/assets/images/activity/23-6-16/size.png'
import downImg from 'src/pc/assets/images/activity/23-6-16/down.png'
import closeBtnImg from 'src/pc/assets/images/christmas-modal/close-btn.png'
import modalHeaderImg from 'src/pc/assets/images/activity/23-6-16/modal-header.png'
import tabBg from 'src/pc/assets/images/activity/23-6-16/tab-bg.png'
import tipIcon from 'src/pc/assets/images/activity/23-6-16/tips-icon.png'
import speedImg from 'src/pc/assets/images/activity/23-6-16/speed-img.png'
import cloudImg from 'src/pc/assets/images/activity/23-6-16/cloud-img.png'
import goodsBg from 'src/pc/assets/images/activity/23-6-16/goods-bg.png'
import goodsTag from 'src/pc/assets/images/activity/23-6-16/goods-tag.png'
import moment from 'moment'
import classNames from 'classnames'

const TIME = 30 * 60 * 1000
const format = (value: number, length: number) => {
  return String(Math.max(value, 0)).padStart(length, '0')
}

//富文本中的img转化为Image组件
const getHTMLComponent = (htmlString: string) => {
  return htmr(htmlString, {
    transform: {
      _: (element, props, children) => {
        if (element === 'img') {
          const src = (props as any)?.src
          return <Image src={fitImgUrl(src, 1312, undefined, 'jpg', 'lfit')} loading="lazy" preview={{ src }} />
        } else if (typeof props === 'undefined') {
          return element
        }
        return React.createElement(element, props, children)
      },
    },
  })
}

const timer: number | null = null
const imgError = (e: SyntheticEvent<HTMLImageElement>) => {
  e.currentTarget.src = DefaultAvatar
}
type TabKey = '特色MOD' | '汉化包' | '精品存档'
const Modal: FC = () => {
  const { userInfo, isLogin } = useIsLogin()
  const [activeGame, setActiveGame] = useState<Activity23616Item>()
  const [activeTabKey, setActiveTabKey] = useState<TabKey>()
  const [itemIndex, setItemIndex] = useState(0)
  const [isThirdPartyGoodsTab, setThirdPartyGoodsTab] = useState<boolean>(false)
  const isSingle =
    AppStore['activity-23-6-16'] &&
    AppStore['activity-23-6-16'].recommendGoodsList.length === 1 &&
    (!AppStore['activity-23-6-16'].hgSpeedGoodsVoList ||
      AppStore['activity-23-6-16'].hgSpeedGoodsVoList.length === 0) &&
    (!AppStore['activity-23-6-16'].cloudGameTimeGoodsVoList ||
      AppStore['activity-23-6-16'].cloudGameTimeGoodsVoList.length === 0)

  const cancelModal = () => {
    AppStore['activity-23-6-16'] && (AppStore['activity-23-6-16'].modalVisible = false)
  }

  const currentList = useMemo(() => {
    if (!activeGame || !activeTabKey) {
      return []
    }
    if (activeTabKey === '特色MOD') {
      return (
        activeGame.gameMODVoList?.map(d => {
          return {
            name: d.productName,
            img: d.listImg,
            desc: d.introduction,
            price: d.activityPrice,
            oldPrice: d.salePrice,
            tag: d.tag || '',
            content: d.gameDesc || '',
            downs: d.downloads || 0,
            size: d.fileSizeDesc || 0,
            sizeField: 'MOD大小',
            imgs: d.detailImg?.split('|') || [],
            id: d.goodsId,
            buy: () => {
              cancelModal()
              toMODBuyDetail(d.goodsId, `?activityNo=${activityNo}`)
            },
          }
        }) || []
      )
    }
    if (activeTabKey === '精品存档') {
      return activeGame.archiveGoodsVoList?.map(d => {
        return {
          name: d.goodsName,
          img: d.listImg,
          desc: d.introduction,
          price: d.activityPrice,
          oldPrice: d.salePrice,
          tag: '',
          content: d.gameDesc || '',
          downs: d.archiveDownloadNum || 0,
          size: d.archiveFileSize && d.archiveFileSizeUnit ? `${d.archiveFileSize}${d.archiveFileSizeUnit}` : 0,
          imgs: [
            d.archiveHighlightOneImg,
            d.archiveHighlightTwoImg,
            d.archiveHighlightThreeImg,
            d.archiveHighlightFourImg,
          ].filter(Boolean),
          id: d.goodsId,
          sizeField: '存档大小',
          buy: () => {
            cancelModal()
            toArchiveBuyDetail(d.goodsId, `?activityNo=${activityNo}`)
          },
        }
      })
    }
    if (activeTabKey === '汉化包') {
      return activeGame.gameChinesizationPackVoList?.map(d => {
        return {
          name: d.productName,
          img: d.listImg,
          desc: d.introduction,
          price: d.activityPrice,
          oldPrice: d.salePrice,
          tag: d.tag || '',
          content: d.gameDesc || '',
          downs: d.downloads || 0,
          size: d.fileSizeDesc || 0,
          id: d.goodsId,
          imgs: [],
          sizeField: '汉化包大小',
          buy: () => {
            cancelModal()
            toChinesePackageBuyDetail(d.goodsId, `?activityNo=${activityNo}`)
          },
        }
      })
    }
    return []
  }, [activeTabKey, activeGame])

  const currentDetail = useMemo(() => {
    const temp = currentList?.[itemIndex]
    return temp
  }, [currentList, itemIndex])

  const isShowThirdPatyGoods = useMemo(() => {
    return (
      (AppStore['activity-23-6-16']?.hgSpeedGoodsVoList &&
        AppStore['activity-23-6-16']?.hgSpeedGoodsVoList.length > 0) ||
      (AppStore['activity-23-6-16']?.cloudGameTimeGoodsVoList &&
        AppStore['activity-23-6-16']?.cloudGameTimeGoodsVoList.length > 0)
    )
  }, [AppStore['activity-23-6-16']])

  const handleInitRecommendGoods = (recommendGoodsList?: Activity23616Item[]) => {
    if (!recommendGoodsList || recommendGoodsList.length === 0) {
      setActiveGame(undefined)
      return
    }
    handleSetActiveGame(recommendGoodsList[0])
  }

  const handleSetActiveGame = (game: Activity23616Item) => {
    setActiveGame(game)
    setItemIndex(0)
    if (!!game.gameMODVoList && game.gameMODVoList.length > 0) {
      setActiveTabKey('特色MOD')
      return
    }
    if (!!game.archiveGoodsVoList && game.archiveGoodsVoList.length > 0) {
      setActiveTabKey('精品存档')
      return
    }
    if (!!game.gameChinesizationPackVoList && game.gameChinesizationPackVoList.length > 0) {
      setActiveTabKey('汉化包')
      return
    }
  }

  useEffect(() => {
    if (isLogin && AppStore['activity-23-6-16'] && AppStore['activity-23-6-16'].recommendGoodsList.length > 0) {
      handleInitRecommendGoods(AppStore['activity-23-6-16'].recommendGoodsList)
    } else {
      handleInitRecommendGoods(undefined)
    }
  }, [AppStore['activity-23-6-16']?.recommendGoodsList, isLogin])

  useEffect(() => {
    if (AppStore['activity-23-6-16']?.modalVisible) {
      window.sensorsdataReportParams?.('BoxClient_HPRecommend_PopupWindow_View', {})
    }
  }, [AppStore['activity-23-6-16']?.modalVisible])

  useEffect(() => {
    if (activeGame && activeTabKey) {
      window.sensorsdataReportParams?.('BoxClient_HPRecommend_Tab_Click', {
        tabType: activeTabKey,
        game_name: activeGame.gameLibrary.gameName,
      })
    }
  }, [activeGame])

  useEffect(() => {
    if (activeGame && activeTabKey && currentDetail) {
      window.sensorsdataReportParams?.('BoxClient_HPRecommend_Tab_Click', {
        goodId: `${activeGame.gameLibrary.gameName}-${currentDetail.id}${currentDetail.name}${activeTabKey}`,
        game_name: activeGame.gameLibrary.gameName,
      })
    }
  }, [currentDetail])

  return (
    <StyledDDModal
      visible={!!AppStore['activity-23-6-16']?.modalVisible}
      footer={false}
      title={null}
      centered
      maskClosable={false}
      width={981}
    >
      <StyledContent>
        <StyledModalHeader>
          <div className="user-box">
            <img
              draggable={false}
              src={(userInfo && userInfo.avatar) || DefaultAvatar}
              className="avatar"
              onError={imgError}
              alt={userInfo?.nickname}
            />
            <div className="desc">
              {userInfo?.nickname || userInfo?.mobile},你的今日
              <span className="main">专属折扣商品</span>
            </div>
          </div>
          <img
            className="close-btn"
            src={closeImg}
            onClick={() => AppStore['activity-23-6-16'] && (AppStore['activity-23-6-16'].modalVisible = false)}
          />
          <div className="last-time">
            <img src={timeImg} />
            <div className="last-text">距结束</div>
            <div className="last-main">
              {AppStore['activity-23-6-16']?.timeText.hours}:{AppStore['activity-23-6-16']?.timeText.minutes}:
              {AppStore['activity-23-6-16']?.timeText.seconds}
            </div>
          </div>
        </StyledModalHeader>
        <StyledModalContent img={isThirdPartyGoodsTab ? '' : activeGame?.gameLibrary?.bgImg || ''}>
          <div className="content-header">
            {isSingle ? (
              <>
                <div className="header-title">
                  {activeGame?.gameLibrary?.gameName}
                  <span style={{ marginLeft: 10, lineHeight: 0 }}>
                    {activeGame?.gameLibrary?.platform && PlatformIconByPlatformName[activeGame?.gameLibrary?.platform]}
                  </span>
                </div>
                <div className="header-desc">{activeGame?.gameLibrary?.englishName}</div>
              </>
            ) : (
              <div
                className={classNames('header-tabs', {
                  small:
                    AppStore['activity-23-6-16']?.recommendGoodsList &&
                    AppStore['activity-23-6-16'].recommendGoodsList.length > 4 &&
                    isShowThirdPatyGoods,
                })}
              >
                {isShowThirdPatyGoods && (
                  <div
                    className={classNames('header-tab-item', {
                      active: isThirdPartyGoodsTab,
                    })}
                    key={`thirdPartyGoods`}
                    onClick={() => {
                      setThirdPartyGoodsTab(true)
                      // window.sensorsdataReportParams?.('BoxClient_HPRecommend_Changegame_Click', {
                      //   game_name: d.gameLibrary.gameName,
                      // })
                    }}
                    style={{ background: `url(${tabBg}) no-repeat`, backgroundSize: 'cover' }}
                  >
                    <div className="header-tab-name textOverflow">游戏搭档</div>
                  </div>
                )}
                {AppStore['activity-23-6-16']?.recommendGoodsList?.map((d, i) => {
                  if (i > 4) {
                    return null
                  }
                  return (
                    <div
                      className={classNames('header-tab-item', {
                        active: !isThirdPartyGoodsTab && d.gameLibrary.id === activeGame?.gameLibrary?.id,
                      })}
                      key={d.gameLibrary.id}
                      onClick={() => {
                        setThirdPartyGoodsTab(false)
                        handleSetActiveGame(d)
                        window.sensorsdataReportParams?.('BoxClient_HPRecommend_Changegame_Click', {
                          game_name: d.gameLibrary.gameName,
                        })
                      }}
                      style={{ background: `url(${d.gameLibrary.listImg}) no-repeat`, backgroundSize: 'cover' }}
                    >
                      <div className="header-tab-name textOverflow">{d.gameLibrary.gameName}</div>
                    </div>
                  )
                })}
              </div>
            )}
          </div>
          {isThirdPartyGoodsTab ? (
            <StyledThirdPartyGoodsContent>
              <StyledThirdPartyGoodsTips>
                <img src={tipIcon} />
                因商品特殊性，不支持发起退款
              </StyledThirdPartyGoodsTips>
              {!!AppStore['activity-23-6-16']?.hgSpeedGoodsVoList &&
                AppStore['activity-23-6-16']?.hgSpeedGoodsVoList?.length > 0 && (
                <StyledThirdPartyGoodsRow>
                  <img src={speedImg} />
                  {AppStore['activity-23-6-16']?.hgSpeedGoodsVoList?.map((d, i) => (
                    <StyledThirdPartyGoodsItem
                      className={classNames({ 'goods-first': i === 0 })}
                      key={`hgSpeedGoodsVoList-${d.goodsId}`}
                      onClick={() => {
                        cancelModal()
                        toBoosterBuyDetailUrl(d.goodsId, `?activityNo=${activityNo}`)
                      }}
                    >
                      <div className="goods-name ellipsis">{d.goodsName}</div>
                      <div className="price-row">
                        <div className="sale-price">
                          <span>¥</span>
                          {d.activityPrice}
                        </div>
                        <div className="cost-price">¥{d.salePrice}</div>
                      </div>
                      <div className="buy-btn">立即购买</div>
                      {i === 0 && <img className="tag" src={goodsTag} />}
                    </StyledThirdPartyGoodsItem>
                  ))}
                </StyledThirdPartyGoodsRow>
              )}
              {!!AppStore['activity-23-6-16']?.cloudGameTimeGoodsVoList &&
                AppStore['activity-23-6-16']?.cloudGameTimeGoodsVoList.length > 0 && (
                <StyledThirdPartyGoodsRow>
                  <img src={cloudImg} />
                  {AppStore['activity-23-6-16']?.cloudGameTimeGoodsVoList?.map((d, i) => (
                    <StyledThirdPartyGoodsItem
                      className={classNames({ 'goods-first': i === 0 })}
                      key={`cloudGameTimeGoodsVoList-${d.goodsId}`}
                      onClick={() => {
                        cancelModal()
                        toCloudTimeBuyDetailUrl(d.goodsId, `?activityNo=${activityNo}`)
                      }}
                    >
                      <div className="goods-name ellipsis">{d.goodsName}</div>
                      <div className="price-row">
                        <div className="sale-price">
                          <span>¥</span>
                          {d.activityPrice}
                        </div>
                        <div className="cost-price">¥{d.salePrice}</div>
                      </div>
                      <div className="buy-btn">立即购买</div>
                      {i === 0 && <img className="tag" src={goodsTag} />}
                    </StyledThirdPartyGoodsItem>
                  ))}
                </StyledThirdPartyGoodsRow>
              )}
            </StyledThirdPartyGoodsContent>
          ) : (
            <div className="content-body">
              <div className="left-box">
                <div className="left-tabs">
                  {[
                    activeGame?.gameMODVoList && activeGame.gameMODVoList.length > 0 ? '特色MOD' : null,
                    activeGame?.archiveGoodsVoList && activeGame.archiveGoodsVoList.length > 0 ? '精品存档' : null,
                    activeGame?.gameChinesizationPackVoList && activeGame.gameChinesizationPackVoList.length > 0
                      ? '汉化包'
                      : null,
                  ]
                    .filter(Boolean)
                    .map(d => {
                      return (
                        <div
                          className={classNames('tabs-item', { active: d === activeTabKey })}
                          onClick={() => {
                            setItemIndex(0)
                            setActiveTabKey(d as TabKey)
                          }}
                          key={d}
                        >
                          {d}
                        </div>
                      )
                    })}
                </div>
                <div className="left-components">
                  {currentList?.map((d, i) => {
                    const isActive = i === itemIndex
                    return (
                      <div
                        key={d.name}
                        className={classNames('left-item-container', { active: isActive })}
                        onMouseEnter={() => setItemIndex(i)}
                      >
                        <div className="left-item-img">
                          <DDImage src={fitImgUrl(d.img || '', 148, 70)} />
                        </div>
                        <div className="left-item-info">
                          <div className="left-item-title">{d.name}</div>
                          {d.desc && <div className="left-item-desc textOverflow">{d.desc}</div>}
                          {d.tag && !d.desc && (
                            <div className="left-item-tags">
                              {d.tag.split(',')?.map((tag, i) => (
                                <div className="tag-item" key={`tag${i}`}>
                                  <div className="tag-item-text ellipsis">{tag}</div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                        <div className="left-item-price-box">
                          <div className="now-price">
                            会员抄底价<span className="main">¥{d.price}</span>
                          </div>
                          <div className="old-price">¥{d.oldPrice}</div>
                        </div>
                        <div className="left-item-actions">
                          <div className="left-item-btn" onClick={() => d.buy()}>
                            立即购买
                          </div>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
              <div className="right-box">
                <div className="right-title textOverflow">{currentDetail?.name}</div>
                {currentDetail?.tag && (
                  <div className="right-tags">
                    {currentDetail?.tag?.split(',')?.map((tag, i) => (
                      <div className="tag-item" key={`tag${i}`}>
                        <div className="tag-item-text ellipsis">{tag}</div>
                      </div>
                    ))}
                  </div>
                )}
                <div className="right-desc">{currentDetail?.desc}</div>
                <div className="right-size-box">
                  <div className="right-size-item">
                    <img src={sizeImg} />
                    <div className="info">
                      <div className="value">{currentDetail?.size}</div>
                      <div className="label">{currentDetail?.sizeField}</div>
                    </div>
                  </div>
                  <div className="right-size-item">
                    <img src={downImg} />
                    <div className="info">
                      <div className="value">{currentDetail?.downs}</div>
                      <div className="label">累计下载</div>
                    </div>
                  </div>
                </div>
                <div className="right-detail-box">
                  <div className="detail-title">简介</div>
                  {currentDetail && getHTMLComponent(currentDetail?.content)}
                </div>
                {currentDetail && currentDetail.imgs.length > 0 && (
                  <div className="right-detail-img">
                    <Image.PreviewGroup>
                      {currentDetail.imgs.map((imgUrl, j) => (
                        <div key={`right-detail-img-${j}`}>
                          <Image src={imgUrl} />
                        </div>
                      ))}
                    </Image.PreviewGroup>
                  </div>
                )}
              </div>
            </div>
          )}
        </StyledModalContent>
        {/* <StyledClose onClick={onHideCase2Modal} /> */}
      </StyledContent>
    </StyledDDModal>
  )
}

// const CountDown = () => {
//   const [countdown, setCountdown] = useState<number>(0)

//   const countdownText = useMemo(() => {
//     const t = moment.duration(countdown)
//     return `${format(t.minutes(), 2)}分 ${format(t.seconds(), 2)}.${format(t.milliseconds(), 3)}秒`
//   }, [countdown])

//   const timerRef = useRef(0)

//   const doCountdown = (time: number) => {
//     const delay = 41
//     if (time <= 0) {
//       clearTimeout(timerRef.current)
//       checkTime()
//       return
//     }
//     timerRef.current = window.setTimeout(() => {
//       const next = time - delay
//       setCountdown(next)
//       doCountdown(next)
//     }, delay)
//   }

//   const checkTime = () => {
//     const endTime = Number(localStorage.getItem(FIRST_RECHARGE_MODAL_TIME))
//     const nowTime = BeijingTime.now()
//     let t = 0
//     //没有结束时间、或者当前时间大于结束时间，重新倒计时
//     if (!endTime || nowTime >= endTime) {
//       localStorage.setItem(FIRST_RECHARGE_MODAL_TIME, String(nowTime + TIME))
//       t = TIME
//     } else {
//       t = endTime - nowTime
//     }
//     setCountdown(t)
//     doCountdown(t)
//   }

//   useEffect(() => {
//     if (AppStore.christmasCase2Visible) {
//       checkTime()
//     } else {
//       timerRef.current && clearTimeout(timerRef.current)
//     }
//   }, [AppStore.christmasCase2Visible])

//   useEffect(() => {
//     return () => {
//       timerRef.current && clearTimeout(timerRef.current)
//     }
//   }, [])

//   return <>{countdownText}</>
// }
const StyledThirdPartyGoodsItem = styled.div`
  width: 160px;
  height: 150px;
  background: #343434;
  border-radius: 8px;
  margin-right: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 5px 0;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  &.goods-first {
    width: 200px;
    background: url(${goodsBg});
  }
  .tag {
    position: absolute;
    left: 0;
    top: -4px;
    display: block;
  }
  &:last-child {
    margin-right: 0;
  }
  .goods-name {
    height: 17px;
    font-size: 16px;
    color: #ffffff;
    line-height: 17px;
    width: 100%;
    text-align: center;
  }
  .sale-price {
    color: #ffffff;
    margin-top: 5px;
    font-weight: bold;
    font-size: 28px;
    span {
      font-size: 14px;
      font-weight: normal;
    }
  }
  .cost-price {
    height: 15px;
    font-size: 14px;
    text-decoration: line-through;
    color: #ffffff;
    line-height: 15px;
    opacity: 0.4;
    text-align: center;
  }
  .buy-btn {
    width: 90px;
    height: 30px;
    background: #3c3020;
    border-radius: 4px;
    text-align: center;
    line-height: 30px;
    font-size: 12px;
    color: #f5be68;
    cursor: pointer;
    display: none;
    margin-top: 3px;
    &:hover {
      filter: brightness(1.1);
    }
  }
  &:hover {
    .price-row {
      display: flex;
      align-items: center;
      justify-content: center;
      .cost-price {
        margin-left: 8px;
        position: relative;
        top: 5px;
      }
    }
    .buy-btn {
      display: block;
    }
    padding: 25px 5px 0;
    background: linear-gradient(0deg, #947757 0%, #584534 100%);
  }
`
const StyledThirdPartyGoodsRow = styled.div`
  display: flex;
  align-items: center;
  width: 897px;
  height: 174px;
  background: #222120;
  border-radius: 8px;
  margin-top: 12px;
`
const StyledThirdPartyGoodsTips = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #ffffff;
  img {
    width: 16px;
    margin-right: 9px;
  }
`
const StyledThirdPartyGoodsContent = styled.div`
  width: 940px;
  height: 424px;
  background: #161616;
  border-radius: 8px;
  padding: 15px 19px;
  position: relative;
  z-index: 10;
`
const StyledModalContent = styled.div<{ img: string }>`
  height: 555px;
  width: 981px;
  padding: 20px;
  background: #2a2a2a;
  border-radius: 0 0 24px 24px;
  position: relative;
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    content: ' ';
    width: 981px;
    opacity: 0.12;
    height: 318px;
    background: url(${props => props.img}) no-repeat;
    z-index: 0;
  }
  .content-body {
    position: relative;
    z-index: 0;
    display: flex;
    justify-content: space-between;
    .left-box {
      width: 644px;
      .left-components {
        height: 372px;
        overflow-y: auto;
        overflow-x: visible;
        &::-webkit-scrollbar {
          display: none;
        }
        .left-item-container {
          width: 632px;
          height: 70px;
          display: flex;
          align-items: center;
          background: #222121;
          margin-bottom: 6px;
          position: relative;
          &::before {
            content: ' ';
            height: 100%;
            width: 0px;
            transition: right 100ms ease 0s, width 100ms ease 0s;
            top: 0;
            right: -0px;
            background: #222121;
            position: absolute;
          }
          &.active {
            background: #453f39;
            &::before {
              background: #453f39;
              right: -12px;
              width: 12px;
            }
          }
          &:hover {
            .left-item-actions {
              display: block;
            }
            .left-item-price-box {
              display: none;
            }
          }
          .left-item-img {
            width: 148px;
            height: 70px;
            img,
            video {
              width: 100%;
              height: 100%;
            }
          }
          .defaultImg {
            width: 38px;
            height: 35px;
          }
          .left-item-info {
            margin-left: 20px;
            .left-item-title {
              width: 320px;
              font-size: 15px;
              line-height: 15px;
              font-family: Alibaba PuHuiTi;
              font-weight: 500;
              color: rgba(255, 255, 255, 0.86);
            }
            .left-item-tags {
              display: flex;
              align-items: center;
              margin-top: 8px;
              .tag-item {
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 5px;
                height: 22px;
                background: rgba(238, 178, 100, 0.3);
                border-radius: 4px;
                margin-right: 4px;
                font-size: 12px;
                font-family: Alibaba PuHuiTi;
                font-weight: 400;
                color: rgba(255, 255, 255, 0.6);
              }
            }
            .left-item-desc {
              margin-top: 12px;
              width: 320px;
              font-size: 12px;
              line-height: 12px;
              font-family: Alibaba PuHuiTi;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.3);
            }
          }
          .left-item-price-box {
            width: 124px;
            text-align: right;
            .now-price {
              font-size: 14px;
              line-height: 14px;
              font-family: Alibaba PuHuiTi;
              font-weight: 400;
              color: #b5b29a;
              .main {
                color: rgba(255, 163, 119, 1);
                margin-left: 4px;
              }
            }
            .old-price {
              font-size: 13px;
              line-height: 13px;
              font-family: Alibaba PuHuiTi;
              font-weight: 400;
              text-decoration: line-through;
              color: rgba(255, 255, 255, 0.5);
              margin-top: 10px;
            }
          }
          .left-item-actions {
            display: none;
            padding-left: 24px;
            .left-item-btn {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 105px;
              height: 34px;
              background: linear-gradient(90deg, #ee9164 0%, #fac393 100%);
              border-radius: 4px;
              font-size: 14px;
              font-family: Alibaba PuHuiTi;
              font-weight: bold;
              color: #63240f;
              cursor: pointer;
              &:hover {
                filter: brightness(1.1);
              }
            }
          }
        }
      }
      .left-tabs {
        display: flex;
        align-items: center;
        width: 632px;
        border-radius: 4px;
        background: rgba(0, 0, 0, 0.3);
        margin-bottom: 16px;
        .tabs-item {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 9px;
          height: 30px;
          font-size: 14px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.86);
          cursor: pointer;
          border-radius: 4px;
          &:hover {
            background: rgba(255, 255, 255, 0.12);
          }
          &.active {
            background: #af6845;
          }
        }
      }
    }
    .right-box {
      width: 298px;
      height: 418px;
      padding: 20px;
      background: #453f39;
      overflow: auto;
      .right-title {
        font-size: 16px;
        max-width: 254px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: rgba(255, 255, 255, 0.86);
      }
      .right-tags {
        display: flex;
        align-items: center;
        margin-top: 15px;
        .tag-item {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 5px;
          height: 22px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 4px;
          margin-right: 4px;
          font-size: 12px;
          font-family: Alibaba PuHuiTi;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);
        }
      }
      .right-desc {
        margin-top: 15px;
        width: 254px;
        font-size: 12px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.3);
        line-height: 18px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .right-detail-box {
        font-size: 14px;
        line-height: 24px;
        padding-bottom: 20px;
        margin-top: 24px;
        font-size: 12px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.3);
        line-height: 18px;
        .detail-title {
          font-size: 14px;
          font-family: Alibaba PuHuiTi;
          font-weight: bold;
          color: rgba(255, 255, 255, 0.86);
          margin-bottom: 15px;
        }
      }
      .right-size-box {
        margin-top: 15px;
        display: flex;
        .right-size-item {
          padding: 0 15px 0 12px;
          display: flex;
          align-items: center;
          min-width: 98px;
          height: 40px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 20px;
          margin-right: 12px;
          .info {
            margin-left: 8px;
            .value {
              font-size: 14px;
              font-family: Alibaba PuHuiTi;
              font-weight: 400;
              color: #ffffff;
              line-height: 14px;
            }
            .label {
              margin-top: 2px;
              font-size: 12px;
              font-family: Alibaba PuHuiTi;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.3);
              line-height: 12px;
            }
          }
        }
      }
    }
  }
  .content-header {
    position: relative;
    z-index: 0;
    height: 95px;
    .header-tabs {
      display: flex;
      align-items: center;
      .header-tab-item {
        width: 147px;
        height: 69px;
        border-radius: 4px;
        margin-right: 25px;
        cursor: pointer;
        position: relative;
        .header-tab-name {
          position: absolute;
          bottom: 0;
          left: 0;
          text-align: center;
          width: 100%;
          font-size: 13px;
          font-weight: 400;
          color: #ffffff;
          background: rgba(0, 0, 0, 0.8);
          border-radius: 0 0 4px 4px;
        }
        &:hover {
          filter: brightness(1.1);
        }
        &.active {
          &::before {
            content: ' ';
            width: 155px;
            height: 77px;
            position: absolute;
            top: -4px;
            left: -4px;
            border: 1px solid rgba(250, 195, 147, 1);
            border-radius: 4px;
          }
        }
      }
    }
    .header-tabs.small {
      .header-tab-item {
        width: 131px;
        height: 69px;
        &.active {
          &::before {
            content: ' ';
            width: 133px;
            height: 71px;
            position: absolute;
            top: -1px;
            left: -1px;
            border: 1px solid rgba(250, 195, 147, 1);
            border-radius: 4px;
          }
        }
      }
    }
    .header-title {
      display: flex;
      align-items: center;
      font-size: 24px;
      font-family: Alibaba PuHuiTi;
      font-weight: bold;
      color: rgba(255, 255, 255, 0.86);
      margin-top: 15px;
      span {
      }
    }
    .header-desc {
      font-size: 12px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.3);
      margin-top: 10px;
    }
  }
`

const StyledModalHeader = styled.div`
  width: 981px;
  height: 90px;
  background: url(${modalHeaderImg}) no-repeat;
  background-size: 100%;
  position: relative;
  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    &:hover {
      filter: brightness(1.1);
    }
  }
  .last-time {
    position: absolute;
    display: flex;
    align-items: center;
    top: 25px;
    right: 88px;
    .last-text {
      margin: 0 4px 0 6px;
      font-size: 14px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #ffffff;
      line-height: 14px;
    }
    .last-main {
      color: rgba(253, 26, 26, 1);
    }
  }
  .user-box {
    display: flex;
    align-items: center;
    position: absolute;
    top: 57px;
    left: 50%;
    transform: translateX(-50%);
    .avatar {
      width: 24px;
      height: 24px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .desc {
      font-size: 16px;
      line-height: 16px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: #ffffff;
      .main {
        color: rgba(250, 193, 145, 1);
        font-weight: 800;
      }
    }
  }
`

const StyledClose = styled.div`
  width: 24px;
  height: 24px;
  background: url(${closeBtnImg});
  background-size: cover;
  cursor: pointer;
  position: absolute;
  z-index: 1;
  bottom: -14px;
  right: 253px;
`
const StyledContent = styled.div`
  position: relative;
`

const StyledDDModal = styled(DDModal)`
  .ant-modal-content {
    background: transparent;
    box-shadow: none;
  }
  .ant-modal-body {
    padding: 0;
    background: transparent;
  }
  .ant-modal-close {
    display: none;
  }
`
export const ActivityModal = hot(observer(Modal))
